import { setLocale, type LocaleObject, printValue } from 'yup';

// Based on https://github.com/LoicMahieu/yup-locales/blob/master/src/locales/it.ts

const mixed: LocaleObject['mixed'] = {
  default: 'Il campo \'${path}\' non è valido.',
  required: 'Il campo \'${path}\' è obbligatorio',
  defined: 'Il campo \'${path}\' deve essere definito',
  notNull: 'Il campo \'${path}\' non può essere nullo',
  oneOf: 'Il campo \'${path}\' deve essere uno dei seguenti valori: ${values}',
  notOneOf: 'Il campo \'${path}\' non deve essere uno dei seguenti valori: ${values}',
  notType: ({ path, type, value, originalValue }) => {
    const isCast = originalValue != null && originalValue !== value;
    let msg
      = `${path} deve essere un tipo \`${type}\`, `
        + `Ma il valore finale era: \`${printValue(value, true)}\``
        + (isCast ? ` (cast dal valore \`${printValue(originalValue, true)}\`).` : '.');

    if (value === null) {
      msg += `\n Se "null" è inteso come valore vuoto, assicurarsi di contrassegnare lo schema come` + ' `.nullable()`';
    }

    return msg;
  },
};

const string: LocaleObject['string'] = {
  length: 'Il campo \'${path}\' deve essere lungo esattamente ${length} caratteri',
  min: ({ path, min }) => `Il campo '${path}' deve contenere almeno ${min === 1 ? 'un carattere' : `${min} caratteri`}`,
  max: 'Il campo \'${path}\' può contenere al massimo ${max} caratteri',
  matches: 'Il campo \'${path}\' deve abbinare quanto segue: \'${regex}\'',
  email: 'Il campo \'${path}\' deve essere un\'e-mail valida',
  url: 'Il campo \'${path}\' deve essere un URL valido',
  uuid: 'Il campo \'${path}\' deve essere un uuid valido',
  trim: 'Il campo \'${path}\' non può contenere spazi iniziali né finali',
  lowercase: 'Il campo \'${path}\' deve contenere solamente caratteri minuscoli',
  uppercase: 'Il campo \'${path}\' deve contenere solamente caratteri maiuscoli',
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error TODO
  phone: ({ path }) => `Il campo ${path} non è un numero di telefono valido`,
};

const number: LocaleObject['number'] = {
  min: 'Il campo \'${path}\' deve essere maggiore o uguale a ${min}',
  max: 'Il campo \'${path}\' deve essere minore o uguale a ${max}',
  lessThan: 'Il campo \'${path}\' deve essere minore di ${less}',
  moreThan: 'Il campo \'${path}\' deve essere maggiore di ${more}',
  positive: 'Il campo \'${path}\' deve essere un numero positivo',
  negative: 'Il campo \'${path}\' deve essere un numero negativo',
  integer: 'Il campo \'${path}\' deve essere un numero intero',
};

const date: LocaleObject['date'] = {
  min: 'Il campo \'${path}\' deve essere successivo alla data ${min}',
  max: 'Il campo \'${path}\' deve essere precedente alla data ${max}',
};

const boolean: LocaleObject['boolean'] = {
  isValue: 'Il campo \'${path}\' deve essere uguale a ${value}',
};

const object: LocaleObject['object'] = {
  noUnknown: 'Il campo \'${path}\' non può contenere chiavi non specificate nello schema',
};

const array: LocaleObject['array'] = {
  min: 'Il campo \'${path}\' deve contenere almeno ${min} elementi',
  max: 'Il campo \'${path}\' deve contenere al massimo ${max} elementi',
  length: 'Il campo \'${path}\' deve avere esattamente ${length} elementi',
};

setLocale({
  mixed,
  string,
  number,
  date,
  boolean,
  object,
  array,
});
